import { User } from "@/types/users"
import { formatCoins } from "../../util/format"

export type Supporter = {
  avatar: Partial<User>
  lastTx: number
  percentage: string
  type: "LIKED" | "LOVED" | "BELIEVER"
}

const SUPPORTER_TYPES: Supporter["type"][] = ["LIKED", "LOVED", "BELIEVER"]

export async function getSupporters(): Promise<Supporter[]> {
  const total = Math.floor(Math.random() * 100)
  const supporters = new Array(total)
    .fill(0)
    .map(() => ({
      avatar: EXAMPLE_AVATARS[Math.floor(Math.random() * 3)],
      lastTx: Date.now() - Math.floor(Math.random() * 86_400_000),
      percentage: `${Math.floor(Math.random() * 8)}.${Math.floor(Math.random() * 99)}`,
      type: SUPPORTER_TYPES[Math.floor(Math.random() * 3)],
    }))
    .sort((a, b) => Number(b.percentage) - Number(a.percentage))

  return Promise.resolve(supporters)
}

export async function sellCoins(
  amount: number
): Promise<{ coins: string; usdValue: string }> {
  return testPromise({
    coins: formatCoins(amount),
    usdValue: (Math.random() * 1e-10 * 2500 * amount).toFixed(2),
  })
}

function testPromise<T>(returnValue: T, failRate = 0.5): Promise<T> {
  const fail = Math.random() < failRate
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      if (fail) reject("TEST ERROR")
      else resolve(returnValue)
    }, 1_000)
  })
}

const EXAMPLE_AVATARS = [
  {
    id: "2915",
    wallet_address:
      "0x0040daac32d83c78546ae36da42a496b28ab09e1" as `0x${string}`,
    lowercase_wallet_address:
      "0x0040daac32d83c78546ae36da42a496b28ab09e1" as `0x${string}`,
    avatar_url:
      "https://imagedelivery.net/BXluQx4ige9GuW0Ia56BHw/bb1410ab-b9d5-490f-3b3a-cdbb20c94b00/original",
    authorName: "Gaurang Desai 🎩🔮",
  },
  {
    id: "19652",
    wallet_address:
      "0x0c321d645e921f7efc8229c0db4827c674b6e3e8" as `0x${string}`,
    lowercase_wallet_address:
      "0x0c321d645e921f7efc8229c0db4827c674b6e3e8" as `0x${string}`,
    avatar_url:
      "https://imagedelivery.net/BXluQx4ige9GuW0Ia56BHw/bc761c40-111f-4b98-d9bd-40c125c28000/rectcrop3",
    authorName: "marisaaa",
  },
  {
    id: "ImMpwqWPjP9zWilOeT1e",
    wallet_address: undefined,
    lowercase_wallet_address: undefined,
    avatar_url:
      "https://storage.googleapis.com/papyrus_images/7eb5a55b7a9c32a88b5a6f12c8cfe613.jpg",
    authorName: "zeck",
  },
]
